import { render, staticRenderFns } from "./EventsFollowCampaignTable.vue?vue&type=template&id=5f1752b8&"
import script from "./EventsFollowCampaignTable.vue?vue&type=script&lang=ts&"
export * from "./EventsFollowCampaignTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
